var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcStarFillEmpty = function SvgIcStarFillEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_star_fill_empty_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    fillRule: "evenodd",
    d: "M11.879 4.155a.71.71 0 0 0-.624-.431l-3.174-.14L6.646.535A.71.71 0 0 0 6 .12a.71.71 0 0 0-.646.414l-1.436 3.05-3.172.14a.71.71 0 0 0-.625.431.73.73 0 0 0 .128.783l2.355 2.537-.89 3.614a.73.73 0 0 0 .244.75c.22.18.511.212.79.073l3.251-1.834 3.28 1.848a.706.706 0 0 0 .763-.087.73.73 0 0 0 .244-.742l-.89-3.622 2.37-2.554a.73.73 0 0 0 .113-.766",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_star_fill_empty_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgIcStarFillEmpty;